import { PeerMessage, PeerMessageType } from '@playcastdotio/Messaging';
import { functionConnectionState, iceServerState } from '../../../stores/shared';
import { rcClientHandlePeerMessage } from '../../remoteClientInterface';
import { realtimeSignalingService } from '../../../../coordinators/init';

export const handlePeerMessage = (message: PeerMessage) => {
  switch (message.type) {
    case PeerMessageType.PEER_GET_ID_ANSWER: {
      if (message.iceServers) {
        console.log('Storing ice servers for peer:', message.peerId, message.iceServers);
        iceServerState.updateState({
          ...iceServerState.currentState,
          remoteClientIceServers: message.iceServers,
        });
      }

      functionConnectionState.updateState({
        ...functionConnectionState.currentState,
        remoteClientId: message.peerId,
      });
      break;
    }
    case PeerMessageType.PEER_ICE_CANDIDATE:
    case PeerMessageType.PEER_SDP_ANSWER:
    case PeerMessageType.PEER_SDP_OFFER: {
      realtimeSignalingService.forwardValidated(message, rcClientHandlePeerMessage);
      break;
    }
  }
};
